import type { MaybeElement } from '@vueuse/core'
import type { RouteLocationNormalized } from '#vue-router'

export const useHomeSwitchCookie = () =>
  useCookie('homeSwitch', {
    default: () => false,
    // flags asked by the Sony DAST (cookie not marked as Secure, no SameSite)
    secure: !import.meta.dev,
    sameSite: 'lax',
  })

export const useModalHeightCSS = () => {
  const modalHeight = useModalHeightState()
  return computed(() => `calc(100dvh - ${modalHeight.value}px)`)
}

export const useModalHeightState = () => useState('modalHeight', () => 106)

// the post API answered 410 Gone (post unpublished, or author banned or deleted): the post page answers 410 too
export const usePostGoneState = () => useState('postGone', () => false)

// the post API answered 404 with the post's path under its own rubric: the post page redirects there (301)
export const usePostMovedState = () =>
  useState<string | null>('postMoved', () => null)

// taken before the loader's await, while the Nuxt context is still there
export const useRedirectMovedPost = () => {
  const postMoved = usePostMovedState()

  return (to: RouteLocationNormalized) =>
    postMoved.value && postMoved.value !== to.path
      ? navigateTo(postMoved.value, { redirectCode: 301 })
      : undefined
}

export const useComputeModalHeight = (
  sonyBar: Ref<MaybeElement>,
  navBar: Ref<MaybeElement>,
) => {
  const targetIsVisible = useElementVisibility(sonyBar)
  const { height: sonyBarHeight } = useElementSize(sonyBar)
  const { height: navBarHeight } = useElementSize(navBar)

  const realSonyBarHeight = computed(() =>
    targetIsVisible.value ? sonyBarHeight.value : 0,
  )

  const modalHeight = computed(
    () => realSonyBarHeight.value + navBarHeight.value,
  )

  const modalHeightState = useModalHeightState()

  watch(modalHeight, (newModalHeight) => {
    modalHeightState.value = newModalHeight
  })
}
